import type { FaireThemeEntity } from "../../entity_types/theme";

export const defaultTheme: FaireThemeEntity = {
  token: "default",
  type: "theme",
  bgColor: "#FFFFFF",
  name: "Default Theme",
  productTokens: ["default"],
  retailerToken: "default",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
